import React from 'react';
import ProductCard from '../ProductCard/ProductCard'; 
import './ProductGrid.css';
// Dil hook'unu ekliyoruz kanka
import { useLanguage } from '../../../context/LanguageContext';

const ProductGrid = ({ products }) => {
  const { t } = useLanguage();

  return (
    <div className="product-grid-wrapper">
      {/* Eğer ürün varsa listele, yoksa uyarı ver */}
      {products && products.length > 0 ? (
        <div className="product-flex-layout">
          {products.map((item, index) => (
            <ProductCard key={item.id || index} product={item} />
          ))}
        </div>
      ) : (
        <div className="no-products">
          {/* Kanka buradaki uyarı metnini dile bağladık */}
          <p>{t('catalog.productGrid.noProducts') || "No products found in this category."}</p>
        </div>
      )}
    </div>
  );
};

export default ProductGrid;